module.exports = __webpack_public_path__ + "img/e-1.e7719f58.jpg";